import { Link } from "react-router-dom";
import "./button.css";

export default function Button({
  children,
  variant = "primary",
  to,
  href,
  className = "",
  ...props
}) {
  const styleClass = variant === "secondary" ? "secondary-btn" : "primary-btn";
  const classes = [styleClass, className].filter(Boolean).join(" ");

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
